// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Frag Amigo',
    assistant: 'Assistent',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Frag Amigo, {{count}} neu',
    amigo_other: 'Frag Amigo, {{count}} neu',
    assistant_one: 'Assistent, {{count}} neu',
    assistant_other: 'Assistent, {{count}} neu',
  },
  unavailable_label: {
    amigo: 'Amigo nicht verfügbar',
    assistant: 'Assistent nicht verfügbar',
  },
  unavailable_text: {
    amigo: 'Amigo ist gerade nicht verfügbar.',
    assistant: 'Der Assistent ist gerade nicht verfügbar.',
  },
};
